export default "__VITE_ASSET__CaLJHJYI__"